
function parseText(str) {
    let pos = 0;

    return {
        consumeSpaces() {
            while (str[pos] === " " || str[pos] === "\n")
                pos++;
        },

        indexOfSpecial(character) {
            let currentPos = pos + 1;

            while (true) {
                const indexOf = str.indexOf(character, currentPos);

                if (indexOf > 1 && str[indexOf - 1] === "\\") {
                    currentPos++;
                    continue;
                }

                return indexOf;
            }
        },

        consume(count) {
            const end  = pos + count;
            const text = str.substring(pos, end);

            // Set new position.
            pos = end;

            // Consume spaces.
            this.consumeSpaces();

            return text;
        },

        readWord() {

            // Consume spaces.
            this.consumeSpaces();

            if (str[pos] == "\"") {
                const endOfString = this.indexOfSpecial("\"");

                if (endOfString == (-1))
                    throw new Error("Missing end of string.");

                // Skip " character.
                pos += 1;

                const text = this.consume(endOfString - pos);

                // Skip " character.
                pos += 1;

                return text;

            } else {
                const endOfString = this.indexOfSpecial(" ");

                return (endOfString == (-1))
                    ? this.consume(str.length - pos)
                    : this.consume(endOfString - pos);
            }
        },
    };
}

export function parseHTMLTags(str) {
    const htmlTagRegex  = /<(\/?[^>]+)>/g;
    const openedTags    = [ [ null, [] ] ];
    let lastIndex       = 0;
    let match;

    while (match = htmlTagRegex.exec(str)) {
        const currentTag    = match[1];
        const slice         = str.substring(lastIndex, match.index);

        if (slice)
            openedTags.at(-1)[1].push(slice);

        lastIndex = match.index + match[0].length;

        // Detect close tag.
        if (currentTag[0] === "/") {
            const entry = openedTags.pop();

            if (entry[0] === currentTag.slice(1)) {
                openedTags.at(-1)[1].push(entry);

            } else {
                throw new Error("Encountered a closing beacon of the wrong type or one that failed to start.");
            }

        } else {
            openedTags.push([ currentTag, [] ]);
        }
    }

    if (openedTags.length > 1)
        throw new Error("A tag is currently opened.");

    // Push final slice.
    {
        const slice = str.substring(lastIndex);

        if (slice.length)
            openedTags[0][1].push(slice);
    }

    return openedTags[0][1];
}

export function parseVariables(str) {
    const regex         = /{([^}]+)}/g;
    const formatParts   = [];
    let lastIndex       = 0;
    let match;

    while (match = regex.exec(str)) {
        const start     = match.index;
        const end       = match.index + match[0].length;
        const slice     = str.substring(lastIndex, start);

        // Push slice.
        if (slice.length)
            formatParts.push(slice);

        // Push content.

        const p         = parseText(match[1]);
        const variable  = p.readWord();
        const operator  = p.readWord();

        if (operator == "?") {
            const defaultVariable = p.readWord();

            formatParts.push({
                type    : "field",
                str     : variable,
                field   : variable.split("."),
                default : defaultVariable,
            });

        } else {
            formatParts.push({
                type    : "field",
                str     : variable,
                field   : variable.split("."),
                default : "",
            });
        }

        // Set last index.
        lastIndex = end;
    }

    // Push final slice.
    {
        const slice = str.substring(lastIndex);

        if (slice.length)
            formatParts.push(slice);
    }

    return formatParts;
}

export function getDeepObjectValue(obj, props) {
    let current = obj;

    for (const prop of props) {

        // Detect if the current key is present in the current object.
        if (!prop in obj)
            throw new Error(`Unable to find "${prop}" in ${current}.`);

        current = current[prop];
    }

    return current;
}
